import { render, staticRenderFns } from "./screenConfig.vue?vue&type=template&id=f47025aa&scoped=true&"
import script from "./screenConfig.vue?vue&type=script&lang=js&"
export * from "./screenConfig.vue?vue&type=script&lang=js&"
import style0 from "./screenConfig.vue?vue&type=style&index=0&id=f47025aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47025aa",
  null
  
)

export default component.exports